import React from 'react';
import PropTypes from 'prop-types';

const ProfileBio = ({ profile, participation }) => (
  <div className={`profile-bio${participation.rankings.length > 0 ? ' with-ranks' : ''}`}>
    <div className="profile-bio-player-info">
      <h1 className="profile-bio-player-info-heading">
        {profile.first_name + ' ' + profile.last_name}
      </h1>
      <div className="profile-bio-player-info-subheading">
        {profile.school.school_name + ', ' + profile.school.city + ", " + profile.school.state}
        <br />
        Class of {profile.graduating_year}
      </div>
    </div>
  </div>
)


ProfileBio.propTypes = {
  profile: PropTypes.object.isRequired,
  participation: PropTypes.object.isRequired
}

export default ProfileBio;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileBio.js